<template>
  <section class="policy policy--info" tabindex="-1">
    <div class="corner-accent" aria-hidden="true"></div>
    <div class="container">
      <div class="intro">
        <div>
          <p class="eyebrow ff-gilroy">SOBRE A UCALL</p>
          <h1 class="ff-gilroy">Tudo sobre a Ucall</h1>
        </div>
        <p class="lede">
          Líder no Atendimento ao Cliente e Contact Center em Angola. Reunimos aqui, de forma organizada,
          todas as informações institucionais da Ucall — quem somos, o que fazemos, números, sectores que
          atendemos e como entrar em contacto.
        </p>
      </div>

      <ul class="sections" role="list">
        <li
          v-for="section in topSections"
          :key="section.id"
          class="sections__item"
        >
          <h2 class="sections__title ff-gilroy">{{ section.title }}</h2>
          <div class="sections__content" v-html="section.content"></div>
        </li>
      </ul>

      <div class="sections__item solutions-block">
        <h2 class="sections__title ff-gilroy">Quais são as soluções da Ucall?</h2>
        <p class="solutions-intro">
          A Ucall organiza a sua oferta em cinco áreas de soluções, desenhadas para responder a diferentes
          necessidades do negócio dos seus clientes:
        </p>
        <ul class="solutions-grid" role="list">
          <li v-for="solution in solutions" :key="solution.id" class="solution-card">
            <span class="solution-card__badge ff-gilroy">{{ solution.code }}</span>
            <h3 class="solution-card__title ff-gilroy">{{ solution.name }}</h3>
            <div class="solution-card__content" v-html="solution.content"></div>
          </li>
        </ul>
      </div>

      <ul class="sections" role="list">
        <li
          v-for="section in bottomSections"
          :key="section.id"
          class="sections__item"
          :class="{ 'sections__item--highlight': section.highlight }"
        >
          <h2 class="sections__title ff-gilroy" :class="{ 'sections__title--onred': section.highlight }">{{ section.title }}</h2>
          <div class="sections__content" :class="{ 'sections__content--onred': section.highlight }" v-html="section.content"></div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'InfoChatBot',
  metaInfo: {
    title: 'Sobre a Ucall - Informações'
  },
  data () {
    return {
      topSections: [
        {
          id: 'quem-somos',
          title: 'O que é a Ucall?',
          content: `<p>A Ucall é a empresa líder em Contact Center e Experiência de Cliente em Angola. Com mais de 17 anos de mercado,
          uma presença sólida e uma carteira de prestigiados clientes nos mais diversos sectores de actividade, o sucesso da Ucall
          está intrinsecamente ligado ao sucesso dos seus clientes, fruto da combinação única de dois factores: uma equipa resiliente
          movida a energia positiva e uma drive para a melhoria contínua e inovação tecnológica.</p>
          <p>Prestando um serviço pautado por elevados padrões de segurança, a vocação da Ucall como parceiro especializado é
          proporcionar a melhor experiência aos clientes, através de processos, sistemas e fluxos de comunicação digitais e
          eficientes, permitindo que os seus parceiros se possam focar no seu negócio.</p>`
        },
        {
          id: 'proposito',
          title: 'Qual é o propósito da Ucall?',
          content: `<p>Transformar experiências, entregando excelência e Inovação, de forma a impactar positivamente o mercado angolano.</p>`
        },
        {
          id: 'valores',
          title: 'Quais são os valores da Ucall?',
          content: `<ul>
            <li><strong>Qualidade e Rigor</strong> — em tudo que entregamos, no cumprimento do que definimos.</li>
            <li><strong>Impacto e Transparência</strong> — em tudo que transformamos, em todos os processos.</li>
          </ul>`
        }
      ],
      solutions: [
        {
          id: 'ucontact',
          code: 'UC',
          name: 'UContact — Contact Center',
          content: `<p>No Contact Center, a Ucall oferece atendimento profissional a clientes, fornecedores e parceiros. Com uma
          abordagem omnicanal e visão 360º, procura proporcionar uma experiência única em cada interacção de vendas, apoio ao
          cliente, assistência técnica, divulgação de soluções e tratamento de processos.</p>
          <ul>
            <li>Atendimento telefónico — Inbound | Outbound | Televendas</li>
            <li>Atendimento em canais digitais — WhatsApp | E-mail | Facebook | Twitter | Webchat | Skype</li>
            <li>Cobranças</li>
            <li>Apoio ao cliente</li>
            <li>Vendas e divulgação de produtos e serviços</li>
            <li>Inquéritos e tratamento de processos (Backoffice: tickets, reclamações, pedidos)</li>
          </ul>`
        },
        {
          id: 'udigital',
          code: 'UD',
          name: 'UDigital — Inovação e Tecnologia',
          content: `<p>A Ucall investe em soluções consistentes, inovadoras e customizadas que permitem transformar processos
          operacionais, optimizar a tomada de decisões, melhorar a experiência de cliente e potenciar resultados. Estes serviços
          disruptivos introduzem inteligência no negócio, impulsionados pela automação e pela transformação digital.</p>
          <ul>
            <li>Plataforma de atendimento de Contact Center</li>
            <li>Business Intelligence — criação e manutenção de modelos de BI e reporting via dashboards, análise de dados e Work Force Management</li>
            <li>Soluções com Inteligência Artificial: <strong>ChatBot (com IA)</strong> e <strong>Speech Analytics (com IA)</strong></li>
            <li>IVR — sistema de atendimento automático</li>
            <li>Sistemas de pagamento automático</li>
          </ul>`
        },
        {
          id: 'uknow',
          code: 'UK',
          name: 'UKnow — Consultoria e Formação',
          content: `<p>Através do serviço de consultoria e diagnóstico, a Ucall mapeia e entende cada negócio, fornecendo insights,
          recomendações e análises detalhadas para impulsionar o crescimento e aprimorar a experiência e a satisfação do cliente.</p>
          <ul>
            <li>Consultoria operacional e tecnológica</li>
            <li>Formação em técnicas de atendimento, gestão de qualidade, vendas e liderança</li>
            <li>Plataforma de E-learning</li>
            <li>Experiência de Cliente — estudos qualitativos que dão visibilidade à voz do cliente</li>
            <li>Insights e tendências do consumidor</li>
          </ul>`
        },
        {
          id: 'utalent',
          code: 'UT',
          name: 'UTalent — Outsourcing de Talento',
          content: `<p>A Ucall atrai e capacita profissionais com o perfil de competências adequado, alocando-os em tempo útil de
          acordo com as exigências do negócio. O objectivo é promover a empregabilidade dos profissionais angolanos e ajudar as
          empresas a alavancarem o seu negócio em contexto de sazonalidade, poupança de recursos ou flexibilidade de headcount.</p>
          <ul>
            <li>Outsourcing de força de vendas</li>
            <li>Outsourcing de recursos especializados</li>
            <li>Plataforma de Outsourcing</li>
          </ul>`
        },
        {
          id: 'umember',
          code: 'UM',
          name: 'UMember — Fidelização',
          content: `<p>A Ucall desenvolve modelos de engagement inovadores como estratégia de fidelização, com foco no
          fortalecimento das relações entre as empresas e os seus clientes, colaboradores e parceiros, criando conexões sólidas
          e duradouras que vão além das transacções comerciais.</p>
          <ul>
            <li>Concierge</li>
            <li>Programas de fidelização à medida</li>
          </ul>`
        }
      ],
      bottomSections: [
        {
          id: 'numeros',
          title: 'Que números demonstram a liderança da Ucall?',
          highlight: true,
          content: `<ul>
            <li><strong>+17 anos</strong> de mercado em Angola</li>
            <li><strong>37 milhões</strong> de interacções por ano</li>
            <li>Equipas qualificadas e especializadas, a operar em sistema presencial e em teletrabalho</li>
          </ul>
          <p>A experiência na gestão e operacionalização de grandes volumes de interacções permite à Ucall agregar know-how no
          desenho de soluções adequadas a cada negócio, com soluções de reporting e análise de dados essenciais para tomadas de
          decisão estratégicas.</p>`
        },
        {
          id: 'sectores',
          title: 'Que sectores e clientes a Ucall atende?',
          content: `<p>A Ucall trabalha em parceria com empresas de referência em diversos sectores do mercado angolano,
          consolidando-se como parceiro estratégico e de confiança:</p>
          <ul>
            <li>Telco &amp; Media</li>
            <li>Banca &amp; Seguros</li>
            <li>Logística &amp; Transportes</li>
            <li>Aviação</li>
            <li>Saúde</li>
            <li>Distribuição</li>
            <li>Estado</li>
            <li>Oil &amp; Gás</li>
          </ul>`
        },
        {
          id: 'cultura',
          title: 'Como é a cultura e a equipa da Ucall?',
          content: `<p>A Ucall é movida a energia positiva. Compromete-se integralmente com o bem-estar e o desenvolvimento
          pessoal e profissional dos seus colaboradores, garantindo formação e acompanhamento contínuos, e valoriza o potencial
          de cada membro das suas equipas — a #EmpresaMaisFelizDeAngola.</p>
          <p style="font-style: italic;">"Na Ucall, todos 'vestimos a camisola' e trabalhamos em equipa e só assim é possível
          estarmos à altura dos desafios a que nos propomos diariamente." — Allen Kaputu, Directora-Geral Adjunta de Serviços</p>`
        },
        {
          id: 'contactos',
          title: 'Como posso contactar a Ucall?',
          content: `<ul>
            <li>Morada: Condomínio Privado Alpha, Lote nº 3, Luanda — Município de Talatona, Bairro de Talatona</li>
            <li>Telefone / WhatsApp: 923 190 190</li>
            <li>E-mail: <a href="mailto:info@ucall.co.ao">info@ucall.co.ao</a></li>
          </ul>`
        },
        {
          id: 'redes-sociais',
          title: 'Onde encontro a Ucall nas redes sociais?',
          content: `<ul>
            <li>Instagram: <a href="https://instagram.com/ucall_oficial" target="_blank" rel="noopener">instagram.com/ucall_oficial</a></li>
            <li>LinkedIn: <a href="https://www.linkedin.com/company/ucall-angola/" target="_blank" rel="noopener">linkedin.com/company/ucall-angola</a></li>
            <li>Facebook: <a href="https://www.facebook.com/youcallangola" target="_blank" rel="noopener">facebook.com/youcallangola</a></li>
            <li>YouTube: <a href="https://www.youtube.com/channel/UCJP8XZ8eAS0NxxdI30kprsQ" target="_blank" rel="noopener">Canal Ucall</a></li>
            <li>TikTok: <a href="https://www.tiktok.com/@ucall_angola" target="_blank" rel="noopener">tiktok.com/@ucall_angola</a></li>
          </ul>`
        },
        {
          id: 'politicas',
          title: 'Onde encontro as políticas legais da Ucall?',
          content: `<ul>
            <li><a href="/politica-de-cookies">Política de Cookies</a></li>
            <li><a href="/politica-de-privacidade">Política de Privacidade</a></li>
            <li><a href="/termos-condicoes">Termos e Condições</a></li>
          </ul>`
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.policy {
  position: relative;
  padding: clamp(6rem, 10vw, 9rem) clamp(1rem, 3vw, 1.5rem) clamp(4rem, 8vw, 7rem);
  color: #1d1d1f;
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  background: #fff;

  .corner-accent {
    position: absolute;
    top: 0;
    right: 0;
    width: clamp(140px, 30vw, 320px);
    height: clamp(140px, 30vw, 320px);
    background: linear-gradient(135deg, #cb3637 0%, #8f1f20 100%);
    clip-path: polygon(100% 0, 100% 100%, 0 0);
    pointer-events: none;
    z-index: 0;
  }

  .container {
    position: relative;
    z-index: 1;
    max-width: min(1000px, 95vw);
    width: 100%;
    margin: 0 auto;
    line-height: 1.75;
    box-sizing: border-box;
    overflow-x: hidden;
  }

  .intro {
    display: grid;
    grid-template-columns: 1fr;
    gap: clamp(0.5rem, 2vw, 1rem) clamp(1rem, 4vw, 2rem);
    align-items: start;
    margin-bottom: clamp(1.5rem, 4vw, 2.5rem);

    .eyebrow {
      display: inline-block;
      font-size: clamp(0.7rem, 2vw, 0.75rem);
      letter-spacing: .12em;
      text-transform: uppercase;
      color: #cb3637;
      font-weight: 700;
      margin: 0 0 clamp(0.25rem, 1vw, 0.5rem);
    }

    .lede {
      color: #4b5563;
      margin: clamp(0.25rem, 1vw, 0.5rem) 0 clamp(0.5rem, 2vw, 1rem);
      font-size: clamp(0.9rem, 2.5vw, 1.0625rem);
      line-height: 1.6;
    }
  }

  h1 {
    font-size: clamp(1.5rem, calc(4vw + 1rem), 2.5rem);
    line-height: 1.2;
    margin: 0 0 clamp(0.75rem, 2vw, 1rem);
    color: #1d1d1f;
    text-transform: uppercase;
    word-break: break-word;
    position: relative;
    display: inline-block;
  }
  h1::after {
    content: "";
    display: block;
    width: clamp(48px, 10vw, 72px);
    height: 5px;
    background: linear-gradient(90deg, #cb3637, #e26e78);
    border-radius: 3px;
    margin-top: clamp(0.5rem, 2vw, 0.75rem);
  }

  p {
    margin: 0 0 clamp(0.75rem, 2vw, 1rem);
    font-size: clamp(0.9rem, 2.5vw, 1.0625rem);
    color: #273249;
    overflow-wrap: anywhere;
    word-break: break-word;
    line-height: 1.6;
  }

  ul {
    padding-left: clamp(1rem, 3vw, 1.25rem);
    margin: clamp(0.25rem, 1vw, 0.5rem) 0 clamp(0.75rem, 2vw, 1rem);
  }
  li {
    margin: clamp(0.25rem, 1vw, 0.5rem) 0;
    padding-left: clamp(0.125rem, 0.5vw, 0.25rem);
    line-height: 1.6;
  }

  a {
    color: #cb3637;
    font-weight: 600;
    text-decoration: underline;
  }
  a:hover {
    color: #8f1f20;
  }
  a:focus {
    outline: 2px solid #cb3637;
    outline-offset: 2px;
  }

  .sections {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    gap: clamp(1.5rem, 4vw, 2.25rem);
  }

  .sections__item {
    position: relative;
    padding: clamp(1.25rem, 3vw, 1.75rem) 0 clamp(1.25rem, 3vw, 1.75rem) clamp(1.1rem, 3vw, 1.4rem);
    border-top: 1px solid #eee;
    border-left: 4px solid #cb3637;
    border-radius: 2px;
  }
  .sections__item:first-child {
    border-top: 0;
  }

  .sections__item--highlight {
    background: linear-gradient(135deg, #cb3637 0%, #8f1f20 100%);
    border-left: 4px solid #f2b8b8;
    border-top: 0;
    border-radius: 12px;
    padding: clamp(1.5rem, 4vw, 2.25rem);
    box-shadow: 0 10px 30px rgba(203,54,55,0.25);
  }

  .sections__title {
    font-size: clamp(1.1rem, 2.8vw, 1.4rem);
    line-height: 1.3;
    color: #1d1d1f;
    text-transform: uppercase;
    margin: 0 0 clamp(0.5rem, 2vw, 0.75rem);
  }
  .sections__title--onred {
    color: #fff;
  }

  .sections__content p,
  .sections__content li {
    color: #1e293b;
    font-size: clamp(0.9rem, 2.5vw, 1rem);
    line-height: 1.6;
  }
  .sections__content--onred p,
  .sections__content--onred li {
    color: #ffe6e6;
  }
  .sections__content--onred strong {
    color: #fff;
    font-size: 1.15em;
  }

  .solutions-block {
    margin: clamp(2.25rem, 5vw, 3rem) 0;
    padding-left: clamp(1.1rem, 3vw, 1.4rem);
    border-left: 4px solid #cb3637;
  }

  .solutions-intro {
    color: #4b5563;
  }

  .solutions-grid {
    list-style: none;
    margin: clamp(0.75rem, 2vw, 1.25rem) 0 0;
    padding: 0;
    display: grid;
    gap: clamp(1rem, 2.5vw, 1.25rem);
    grid-template-columns: 1fr;
  }

  .solution-card {
    position: relative;
    background: #fdf1f1;
    border-top: 4px solid #cb3637;
    border-radius: 10px;
    padding: clamp(1.25rem, 3vw, 1.5rem) clamp(1.25rem, 3vw, 1.5rem) clamp(1.25rem, 3vw, 1.5rem) clamp(3.25rem, 8vw, 4rem);
    transition: box-shadow .2s ease, transform .2s ease;
  }
  .solution-card:hover {
    box-shadow: 0 10px 24px rgba(203,54,55,0.18);
    transform: translateY(-2px);
  }

  .solution-card__badge {
    position: absolute;
    top: clamp(1.1rem, 3vw, 1.4rem);
    left: clamp(1.1rem, 3vw, 1.4rem);
    width: clamp(2rem, 5vw, 2.4rem);
    height: clamp(2rem, 5vw, 2.4rem);
    border-radius: 999px;
    background: #cb3637;
    color: #fff;
    font-weight: 700;
    font-size: clamp(0.75rem, 2vw, 0.85rem);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .solution-card__title {
    margin: 0 0 clamp(0.5rem, 2vw, 0.75rem);
    font-size: clamp(1rem, 2.5vw, 1.15rem);
    color: #8f1f20;
    text-transform: uppercase;
  }

  .solution-card__content p,
  .solution-card__content li {
    color: #1e293b;
    font-size: clamp(0.88rem, 2.4vw, 0.98rem);
    line-height: 1.6;
  }
}

@media (min-width: 481px) and (max-width: 767px) {
  .policy {
    padding: clamp(2.5rem, 5vw, 3.5rem) clamp(1.25rem, 3vw, 1.5rem) clamp(4.5rem, 7vw, 6rem);
  }
}

@media (min-width: 768px) {
  .policy {
    padding: clamp(3rem, 6vw, 4rem) clamp(1.5rem, 4vw, 2rem) clamp(5rem, 8vw, 7rem);
  }
  .policy .intro {
    grid-template-columns: 1.1fr 1fr;
    align-items: center;
  }
  .policy .solutions-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1200px) {
  .policy {
    padding: 6rem 2rem 8rem;
  }
}

@media (max-width: 480px) {
  .policy {
    padding: clamp(2rem, 5vw, 3.25rem) clamp(0.75rem, 2vw, 1rem) clamp(4rem, 8vw, 6.5rem);
  }
  .policy .corner-accent {
    width: 90px;
    height: 90px;
  }
}

@media (max-height: 500px) and (orientation: landscape) {
  .policy {
    padding: clamp(1.5rem, 3vw, 2rem) clamp(1rem, 2vw, 1.5rem) clamp(2rem, 4vw, 3rem);
  }
}
</style>
